import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Cookies from "js-cookie";
// 时间
import timeFun from '@/utils/timeFun';
Vue.prototype.$timeFun = timeFun;
// iconfont 图标库引入
import "./assets/css/iconfont.css"
// cookie工具
Vue.prototype.$Cookies = Cookies;
// 引入cookie
import VueCookies from "vue-cookies";
Vue.prototype.$cookie = VueCookies;
Vue.use(VueCookies); //挂载到全局
// RSA加密
import JsEncrypt from "jsencrypt";
Vue.prototype.$jsEncrypt = JsEncrypt;
// rem
import "@/utils/rem"
// vue2-org-tree
import Vue2OrgTree from 'vue2-org-tree'
Vue.use(Vue2OrgTree)

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium ', zIndex: 3000 });

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
